import { render, staticRenderFns } from "./fourEmotionsMap.vue?vue&type=template&id=0ca14e62&scoped=true"
import script from "./fourEmotionsMap.vue?vue&type=script&lang=js"
export * from "./fourEmotionsMap.vue?vue&type=script&lang=js"
import style0 from "./fourEmotionsMap.vue?vue&type=style&index=0&id=0ca14e62&prod&lang=css"
import style1 from "./fourEmotionsMap.vue?vue&type=style&index=1&id=0ca14e62&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ca14e62",
  null
  
)

export default component.exports